


















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';


@Component
export default class InfoColumnItem extends Vue {
  @Prop() title!: string;
  @Prop() value!: string;
  @Prop() icon!: string;
  @Prop() bg!: string;

  get hasDefaultSlot () {
    return !!this.$slots.default
  }
}
